import { convertTo16kWav } from "../../utils/helpers/aiAgent/convertTo16kWav";
import { useRef, useState } from "react";

const MIN_DURATION_MS = 400;

const useVoiceRecorder = ({ onRecordingStop, sendText, onError, lang }) => {
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const startTimeRef = useRef(null);
  const recognitionRef = useRef(null);

  const [isRecording, setIsRecording] = useState(false);

  const startAm = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };

      mediaRecorder.onstop = async () => {
        const duration = Date.now() - startTimeRef.current;
        if (duration < MIN_DURATION_MS) {
          setIsRecording(false);
          return;
        }
        const wavBlob = await convertTo16kWav(audioChunksRef.current);
        onRecordingStop(wavBlob);
        setIsRecording(false);
      };

      mediaRecorder.start();
      startTimeRef.current = Date.now();
      setIsRecording(true);
    } catch {
      onError();
    }
  };

  const stopAm = () => {
    mediaRecorderRef.current?.stop();
    setIsRecording(false);
  };

  const startEn = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      onError();
      return;
    }

    const recognition = new SpeechRecognition();
    recognitionRef.current = recognition;

    recognition.lang = "en-US";
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.onresult = (e) => {
      const transcript = e.results[0][0].transcript.trim();
      sendText(transcript);
    };

    recognition.onerror = () => {
      setIsRecording(false);
      onError();
    };

    recognition.onend = () => {
      setIsRecording(false);
    };

    recognition.start();
    setIsRecording(true);
  };

  const stopEn = () => {
    recognitionRef.current?.stop();
    setIsRecording(false);
  };

  const toggle = () => {
    if (lang === "en") {
      isRecording ? stopEn() : startEn();
    } else {
      isRecording ? stopAm() : startAm();
    }
  };

  return { isRecording, toggle };
};

export default useVoiceRecorder;